import { ObstacleSettings } from "../ObstacleSettings";
import { eObstacleType } from "../ObstacleTypes";



export class CannonObsSettings extends ObstacleSettings {
    /**
     * (RO) Vzdalenost od hrace, kdy dojde k vystrelu
     */
    get shotDistance(): number { return this._shotDistance; }
    private _shotDistance: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(version: number, shotDistance: number) {
        super(eObstacleType.cannon, version)
        this._shotDistance = shotDistance;
    }
}